import React, { useEffect, useState } from "react"
import { List, Paper, Typography, InputBase, Box, Divider } from "@mui/material"
import SearchIcon from "@mui/icons-material/Search"
import useTranslationSharie from "../hooks/Language/useTranslation"
import UserSection from "../Marketplace/UserSection/UserSection"
import { useApiService } from "../hooks/Api/useApiService"

const UsersList = ({ users }) => {
  const [real_users, setRealUsers] = useState([])
  const [search, setSearch] = useState("")
  const t = useTranslationSharie()
  const { postData } = useApiService()

  useEffect(() => {
    postData("users/getusers", { addressee: users }).then((data) => {
      setRealUsers(data?.users || [])
    })
  }, [users])

  // Filter users based on search input
  const filteredUsers = real_users.filter((user) =>
    user?.user_name?.toLowerCase().includes(search?.toLowerCase())
  )

  return (
    <Paper
      sx={{
        borderRadius: "16px",
        overflow: "hidden",
        boxShadow: 4,
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      {/* HEADER */}
      <Box
        sx={{
          background: (theme) =>
            `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
          color: "text.primary",
          p: 2,
        }}
      >
        <Typography variant='h6' fontWeight='bold'>
          {t("Users")}
        </Typography>
        <Typography variant='body2'>{t("Find users in your organization")}</Typography>
      </Box>

      {/* SEARCH BAR */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          px: 2,
          py: 1,
          bgcolor: "grey.100",
        }}
      >
        <SearchIcon color='primary' sx={{ mr: 1 }} />
        <InputBase
          placeholder={t("Search Users")}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          sx={{
            flex: 1,
          }}
        />
      </Box>

      <Divider />

      {/* USER LIST */}
      <Box sx={{ flexGrow: 1, overflowY: "auto", p: 2 }}>
        {filteredUsers.length > 0 ? (
          <List disablePadding>
            {filteredUsers.map((user, index) => (
              <UserSection key={index} user={user} />
            ))}
          </List>
        ) : (
          <Typography variant='body2' color='textSecondary' align='center' sx={{ mt: 2 }}>
            {t("No users found")}
          </Typography>
        )}
      </Box>
    </Paper>
  )
}

export default React.memo(UsersList)
